import { generateIconComponent } from './icons.utils';

export const CloseSolidIcon = generateIconComponent({
    name: 'CloseSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <>
            <rect
                x="20.6111"
                y="1.52588e-05"
                width="4.79256"
                height="29.1486"
                rx="1"
                transform="rotate(45 20.6111 1.52588e-05)"
            />
            <rect
                x="24"
                y="20.6111"
                width="4.79256"
                height="29.1486"
                rx="1"
                transform="rotate(135 24 20.6111)"
            />
        </>
    ),
});
